import PureLoadable from 'react-17-pure-loadable';

export default PureLoadable({
  loader: () => import('./DataGridPagination.jsx'),
  displayName: 'DataGridPagination',
});
